import gql from 'graphql-tag';

export const GET_PROPOSAL_PRODUCTS = gql`
  query GetProductsForAftermarketConstructor($input: ProposalProductsInput) {
    proposalProducts(input: $input) {
      cost
      title
      proposalProductId
      markup {
        type
        markup
      }
      retailCost
      thirdPartyUrl
      createdDateTime
      modifiedDateTime
      aftermarketProduct {
        criteria
        productName
        productType
        productLogoUrl
        productCategory
        productIsNoLongerAvailable
        createdDateTime
        modifiedDateTime
        aftermarketProductId
        productDescriptionExternal
        productDescriptionInternal
        aftermarketVendorApiChannel
        config {
          criteriaValues
        }
        aftermarketProductCatalogDetails {
          productSummary
          legalDisclaimer
          coverageDetails
          paragraphDescription
          limitationsOfLiability
          eligibilityAndInclusions
        }
        partnerLinks {
          name
          partnerLinkId
        }
        documents {
          documentId
          docName
          source
        }
      }
    }
  }
`;
